import React, { ReactNode } from "react";
import styled from "styles/styled_components";

interface ITooltip extends IStyledTooltip {
  children: ReactNode;
}

interface IStyledTooltip {
  pointer?: "left" | "right";
  pointerBottom?: boolean;
  width: TOOLTIP_WIDTHS;
}

export const POINTER_SIZE = 21;
export enum TOOLTIP_WIDTHS {
  small = 225,
  medium = 300,
  large = 460,
}

const StyledTooltip = styled("div")<IStyledTooltip>`
  background-color: ${(props) => props.theme.colors.brandWhite};
  border: thin solid ${(props) => props.theme.colors.dsGrayLight};
  font-size: ${(props) => props.theme.text.size.base};
  padding: ${(props) => props.theme.spacing.medium};
  width: ${(props) => `${props.width}px`};

  ${({ pointer, pointerBottom, theme }) =>
    pointer &&
    `
  &:after,
  &:before {
    ${pointerBottom ? "bottom: 10px" : "top: 50%"};
    border: solid transparent;
    border-width: ${POINTER_SIZE}px;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    transform: translateY(-50%);
  }

  &:after {
    ${pointer === "left" ? "border-right-color" : "border-left-color"}: ${
      theme.colors.brandWhite
    };
    ${
      pointer === "left"
        ? `left: ${-2 * POINTER_SIZE + 2}px`
        : `right: ${-2 * POINTER_SIZE + 2}px`
    };
  }
  &:before {
    ${pointer === "left" ? "border-right-color" : "border-left-color"}: ${
      theme.colors.dsGrayLight
    };
    ${
      pointer === "left"
        ? `left: ${-2 * POINTER_SIZE}px`
        : `right: ${-2 * POINTER_SIZE}px`
    };
  }
  `}
`;

function Tooltip({ children, pointer, pointerBottom, width }: ITooltip) {
  return (
    <StyledTooltip
      pointer={pointer}
      pointerBottom={pointerBottom}
      width={width}
    >
      {children}
    </StyledTooltip>
  );
}
export default Tooltip;
